import React from 'react';
import { BonusSection } from './components/BonusSection';
import { ChecklistSection } from './components/ChecklistSection';
import { FAQ } from './components/FAQ';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Hero } from './components/Hero';
import { MetaPixel } from './components/MetaPixel';
import { ModulesSection } from './components/ModulesSection';
import { PremiumSection } from './components/PremiumSection';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { SocialProof } from './components/SocialProof';
import { Testimonials } from './components/Testimonials';
import { UrgencySection } from './components/UrgencySection';
export function App() {
  return <div className="min-h-screen w-full overflow-hidden bg-base text-ink" data-id="element-0" data-mp="23v2uj6wqr76z">
    <MetaPixel data-id="element-1" data-mp="3ij63w8owfj7c" />
    <main data-id="element-2" data-mp="3ijpbavgxap74">
      <Hero data-id="element-3" data-mp="3ihv048vgebg8" />
      <SocialProof data-id="element-4" data-mp="3ii4ppvcl6gle" />
      <Testimonials data-id="element-5" data-mp="3ml14faz09sk2" />
      <ProblemSection data-id="element-6" data-mp="3mkhn9wh6j873" />
      <ModulesSection data-id="element-7" data-mp="3mjzpgvevclx2" />
      <ChecklistSection data-id="element-8" data-mp="3mj6jvxrnc2gi" />
      <BonusSection data-id="element-9" data-mp="3rbr9so7flver" />
      <UrgencySection data-id="element-10" data-mp="3rdas0kcnegj6" />
      <PricingSection data-id="element-11" data-mp="3rcsuzli5vya7" />
      <PremiumSection data-id="element-12" data-mp="3relvej26lm9r" />
      <GuaranteeSection data-id="element-13" data-mp="5opww5kum4f" />
      <FAQ data-id="element-14" data-mp="4wwnrzgd0hb" />
      <FinalCta data-id="element-15" data-mp="5gez9t0lqvv" />
    </main>
    <Footer data-id="element-16" data-mp="82ohezguggq" />
    <PurchaseNotification data-id="element-17" data-mp="2zl3bdjx5744s" />
  </div>;
}